import { createSelector } from '@reduxjs/toolkit';
import { Flags } from '@yme/common/assets';
import { COUNTRY_MAPPING } from '@yme/components/FooterBottomMenu/constants';
import { getCommon, getCurrentCountryConfig, getCurrentLanguages, getCurrentNavigationLink, } from '@yme/selectors/common';
const getButtonLabel = createSelector(getCommon, (common) => {
    const countryObj = common.countries.find((country) => country.code === common.initialCountryRoot);
    const languageObj = countryObj?.languages.find((language) => language.code === common.initialLanguageRoot);
    return `${countryObj?.name} (${languageObj?.name})`;
});
const getButtonIcon = createSelector(getCommon, (common) => Flags[COUNTRY_MAPPING[common.initialCountryRoot]]);
const getLanguage = createSelector(getCommon, (common) => ({
    country: common.initialCountryRoot,
    language: common.initialLanguageRoot,
}));
export const getLanguageSelectorProperties = createSelector([
    getCurrentCountryConfig,
    getButtonLabel,
    getCurrentLanguages,
    getCurrentNavigationLink,
    getButtonIcon,
    getLanguage,
], (currentCountryConfig, buttonLabel, languages, navigationLink, buttonIcon, currentLanguage) => ({
    currentCountryConfig,
    buttonLabel,
    languages,
    navigationLink,
    buttonIcon,
    currentLanguage,
}));
